import React from 'react';
import Title from './title';
import Description from './description';
import ProductAddToCart from './addToCart';
import ProductVariants from './variants';
import ProductIngredients from './ingredients';

const StarRating = ({ ratings, loading }) => {
  const count = ratings.ratingCount;
  const rating = ratings.ratingValue;

  const fullStars = rating && !loading ? Math.round(rating) : 0;
  const hasHalfStar = rating > fullStars && !loading;
  const emptyStars = 5 - (hasHalfStar ? fullStars + 1 : fullStars);

  const className =
    'product-summary__star-rating' +
    (count ? '' : ' product-summary__star-rating--no-ratings');

  return (
    <div className={className}>
      {Array(fullStars)
        .fill()
        .map((_, i) => (
          <span className="fa fa-star" key={`${i}-${fullStars}`} />
        ))}
      {hasHalfStar && <span className="fa fa-star-half-o" />}
      {Array(emptyStars)
        .fill()
        .map((_, i) => (
          <span className="fa fa-star-o" key={`${i}-${emptyStars}`} />
        ))}
    </div>
  );
};

export default function ProductSummary(props) {
  const product = props.product || {};
  const { title, subtitle, description } = product;
  const ratings = props.ratings || {};
  const ingredientsWithOptions = (product.ingredients || []).filter(
    ingredient => !!(ingredient.options || []).length
  );

  return (
    <div className="product-summary">
      <section className="product-summary__section">
        <Title title={title} subtitle={subtitle} />
      </section>

      <section className="product-summary__section">
        <StarRating ratings={ratings} loading={props.loadingDetails} />
      </section>

      <section className="product-summary__section">
        <div className="row">
          <div className="col-xs-12 col-sm-10 col-md-9">
            <ProductVariants product={product} />
          </div>
        </div>
      </section>

      {!!ingredientsWithOptions.length && (
        <section className="product-summary__section">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-md-9">
              <ProductIngredients
                ingredients={ingredientsWithOptions}
                sku={product.sku_id}
              />
            </div>
          </div>
        </section>
      )}

      <section className="product-summary__section">
        <div className="row">
          <div className="col-xs-12 col-sm-10 col-md-9">
            <ProductAddToCart product={product} />
          </div>
        </div>
      </section>

      <section className="product-summary__section">
        <div className="row">
          <div className="col-xs-12">
            <Description description={description} />
          </div>
        </div>
      </section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/components/product/summary.js